import React, { ComponentState, useEffect, useState } from 'react';
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
} from 'recharts';
import { Paper, Typography } from '@mui/material';
import { useSelector } from "react-redux";
import { staffChartModel } from 'src/dataModels/docListModel';
import { totalHoursAndMinutes } from 'src/util/utility';
import Loader from "../../../control-components/loader/loader";
import { userIsSuperAdmin } from 'src/helper/permission-helper';

const StaffDocumentsChart = () => {
    const state: ComponentState = useSelector(states => {
        return states;
    })
    const staffLoginInfo = useSelector((state:ComponentState) => state.getStaffReducer);
    const isBillingManager = state.getRolePermission.isBillingManager
    const [chartData, setChartData] = useState<staffChartModel[]>([])
    const { documentStaffChartListResp } = state['DocumentReducer'];
    const userIsSA=userIsSuperAdmin(staffLoginInfo?.roleId)
    const canShowBillData=(isBillingManager || userIsSA)

    useEffect(() => {
        setChartData([])
        if (documentStaffChartListResp && documentStaffChartListResp?.resultData) {
            // Sort the data by 'totDocs' in descending order
            const sortedData = documentStaffChartListResp?.resultData?.slice().sort((a, b) => b.totDocs - a.totDocs);
            // Get the top 10 staff members with the most 'totDocs'
            const topStaff = sortedData.slice(0, 20);
            topStaff?.map((item) => {
                const minutes = totalHoursAndMinutes(item?.totalMinutes)
                const totalbillValue = Number(item?.totalBilled).toFixed(2);
                const formattedTotalBill = new Intl.NumberFormat('en-US', {
                    style: 'currency',
                    currency: 'USD'
                }).format(Number(totalbillValue));
                const label = `Docs: ${item?.totDocs}, Time: ${minutes} ${canShowBillData ? ", Billed Amt:" + " " + formattedTotalBill : ""}`
                var obj: staffChartModel = { staffName: item?.staffName, documents: item?.totDocs, info: label }
                setChartData((oldItem) => [...oldItem, obj])
            })
        }
    }, [documentStaffChartListResp])

    // Find the staff member with the most documents
    const mostDocumentsStaff = chartData[0];
    const mostDocumentsCount = mostDocumentsStaff ? mostDocumentsStaff?.documents : 0;
    return (
        <>
            {documentStaffChartListResp?.resultData?.length != 0 ?
                <Paper elevation={3} style={{ padding: '20px 0' }}>
                    <Typography variant="h6" style={{ fontSize: 15 }}>
                        Staff with most documents: {mostDocumentsStaff?.staffName} ({mostDocumentsStaff?.info})
                        {/* `Docs: ${item?.totDocs}, Time: ${minutes}, ${isBillingManager ? "Billed Amt:" + " " + formattedTotalBill : ""}` */}
                    </Typography>
                    <ResponsiveContainer width="100%" height={350}>
                        <BarChart data={chartData} >
                            <CartesianGrid stroke="transparent" strokeWidth={0} />
                            <XAxis dataKey="staffName" />
                            <YAxis />
                            <Tooltip 
                            cursor={false}
                            content={(props) => {
                                const { payload } = props;
                                if (payload && payload.length > 0) {
                                    const dataItem = payload[0].payload; // Extract the data item
                                    return (
                                        <div className="custom-tooltip">
                                            <p>{dataItem.staffName}</p>
                                            <p>{dataItem.info}</p>
                                        </div>
                                    );
                                }
                                return null;
                            }} />
                            {/* <Legend /> */}
                            <Bar  dataKey="documents" fill="#B800D8" background={false} />
                        </BarChart>
                    </ResponsiveContainer>
                </Paper>
                : <p>No Record found</p>}
        </>

    );
};

export default StaffDocumentsChart;